import httpClient from "./httpClient";

const TOKEN_KEY = "cbrne_token";
const USER_KEY = "cbrne_user";

const AuthService = {
  async login(email, password) {
    const { data } = await httpClient.post("/auth/login", { email, password });
    if (data?.token) {
      localStorage.setItem(TOKEN_KEY, data.token);
      localStorage.setItem(USER_KEY, JSON.stringify(data.member));
    }
    return data;
  },

  async changePassword(currentPassword, newPassword) {
    const { data } = await httpClient.post("/auth/change-password", { currentPassword, newPassword });
    return data;
  },

  logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },

  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  getUser() {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY));
    } catch {
      return null;
    }
  },

  isAuthenticated() {
    return Boolean(AuthService.getToken());
  },
};

export default AuthService;
